<app-toolbar></app-toolbar>

<div class="hmn-page__with-toolbar hmn-unit-details__grid hmn-grid__gap hmn-padding__x4">
  <app-unit-details-header
    (month_change)="onMonthChange($event)"
    (year_change)="onYearChange($event)"></app-unit-details-header>

  <app-unit-details-info class="hmn-hidden__before-lg"></app-unit-details-info>

  <app-unit-details-calendar
    [current_month]="current_month"
    [current_year]="current_year"></app-unit-details-calendar>
</div>
